/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'note': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8.242 16C3.582 16 0 12.418 0 8.242 0 3.582 3.582 0 8.242 0 12.418 0 16 3.582 16 8.242 16 12.418 12.418 16 8.242 16zM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM6.5 6H9v6h1v.5H6.5V12h1V6.5h-1V6zM8 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" _fill="#C7C7C7" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/note.js